import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Skeleton from 'react-loading-skeleton';
import apiClient from '../../utils/api-client';
import PageHeader from './../Common/PageHeader';
import AboutHomeProd from './AboutHomeProd';
import ProductList from './ProductList';
import './ShopPage.css';
const ShopPage = () => {
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    apiClient
      .get('/category')
      .then((res) => {
        setCategories(res.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setIsLoading(false);
      });
  }, []);
  return (
    <>
      <Helmet>
        <title>
          Online Shopping Stores - Online Shopping in Lahore - Karachi
        </title>
        <meta
          name="keywords"
          content="creative items,unique items,creative items to sell,creative craft items,creative gift items,creative home decor products,unique home accessories,best home decor gifts,unique kitchen decor,unique modern home decor,unique decorative items,unique house accessories,cheap home decor gifts,unique kitchen products,unique kitchenware itemsunique kitchen items,home and kitchen unique products,unique kitchen accessories,unique kitchen tools"
        />
        <meta
          name="description"
          content="Planning for online jewellery & gift shopping? Try Bakumia & get your desired products in online in Islamabad, Multan, Faisalabad & all across the Pakistan."
        />
      </Helmet>

      <PageHeader title="Shop" />

      <section className="append_products">
        <div className="container-fluid p-5">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <ProductList />
            </div>
          </div>

          <AboutHomeProd />
        </div>
      </section>
    </>
  );
};
export default ShopPage;
